import script from "./WageSummaryView.vue?vue&type=script&setup=true&lang=js"
export * from "./WageSummaryView.vue?vue&type=script&setup=true&lang=js"

import "./WageSummaryView.vue?vue&type=style&index=0&id=740454aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-740454aa"]])

export default __exports__